// extracted by mini-css-extract-plugin
export var bodyCaption = "newsGrid-module--bodyCaption--F93G+";
export var newsFourthColumns = "newsGrid-module--newsFourthColumns--UhkY4";
export var newsFourthColumnsLessBottom = "newsGrid-module--newsFourthColumnsLessBottom--N6vqV";
export var newsThreeColumns = "newsGrid-module--newsThreeColumns--+tQ0H";